import { render, staticRenderFns } from "./ReservationChangeView.vue?vue&type=template&id=0bedc234&"
import script from "./ReservationChangeView.vue?vue&type=script&lang=js&"
export * from "./ReservationChangeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports